// DataLoader.jsx
// TODO: once we validate that we don't require anymore VouchersDetails and Searches, drop them, their components and their endpoints
// TODO: remove after the comments with the old version
// TODO: eventually we should update the store.js file

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Axios from "axios";

import {
    ARO_ALL,
    DEFAULT_HOTEL,
    GBH_ID,
    ILH_HOTEL_LIST,
    SanitizeHotelID,
    URLAPI,
    YEARS_BEFORE,
} from "../configuration";

import { months } from "../helpers/dates";
import { fetchEventsBundle } from "../helpers/events";

// import {
//     load as load_VouchersDetails,
//     loading as loading_VouchersDetails,
//     error as error_VouchersDetails,
// } from "../actions/dataVouchersDetails";

// import {
//     partialLoad as partialLoad_Searches,
//     load as load_Searches,
//     loading as loading_Searches,
//     error as error_Searches,
// } from "../actions/dataSearches";

// import { load as load_Settings } from "../actions/settings";

import {
    partialLoad as partialLoad_Membership,
    load as load_Membership,
    loading as loading_Membership,
    error as error_Membership,
} from "../actions/dataMembership";

import {
    partialLoad as partialLoad_Simple,
    load as load_Simple,
    loading as loading_Simple,
    error as error_Simple,
} from "../actions/dataSimple";

import { TOTAL_YEARS_NEEDED } from "../features/commissions/dataCommissionsSlice";
import { useLazyGetCommissionsQuery } from "../features/commissions/commissionsApi";

import { useGetBookingsQuery } from "../features/bookings/bookingsApi";
import {
    load_Bookings,
    partiallyLoad_Bookings,
    loading_Bookings,
} from "../features/bookings/dataBookingsSlice";

import {
    load_Searches,
    partiallyLoad_Searches,
    loading_Searches,
} from "../features/searches/dataSearchesSlice";

import LoadingBubble from "./LoadingBubble";
import { BUBBLES_DATA } from "./SideMenu";
import { HotelSelector } from "./TopBar";
import {
    Box,
    Button,
    CircularProgress,
    Modal,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import Icons from "../helpers/icons";
import CheckShow from "./shared/CheckShow";
import { useGetSearchesQuery } from "../features/searches/searchesApi";

import { useGetTargetsQuery } from "../features/targets/targetsApi";
import { useCacheRefresh } from "../helpers/useCacheRefresh";
import {
    load_Targets,
    load_ManualTargets,
    loading_Targets,
    error_Targets,
} from "../features/targets/dataTargetsSlice";

export const reservationsToYearMonth = (data, column) => {
    let res = {};
    data.forEach((element) => {
        const year_ = new Date(element[column]).getUTCFullYear();
        const month_ = new Date(element[column]).getUTCMonth();
        if (!res.hasOwnProperty(year_)) res[year_] = {};
        if (!res[year_].hasOwnProperty(months[month_]))
            res[year_][months[month_]] = [];
        res[year_][months[month_]].push(element);
    });

    return res;
};

export const MONTHS_AGO = 24;
export const timesFirstReservations = () => {
    const year = new Date().getUTCFullYear();
    const currentMonth = new Date().getUTCMonth();
    const fromTime = new Date(Date.UTC(year, currentMonth - MONTHS_AGO, 1)); // HERE
    const toTime = new Date(Date.UTC(year + 2, 0, 0)); // Actual Year + 1
    return { year, currentMonth, fromTime, toTime };
};
export const timesSecondReservations = () => {
    const year = new Date().getUTCFullYear();
    const currentMonth = new Date().getUTCMonth();
    const fromTime = new Date(Date.UTC(year - YEARS_BEFORE, 0, 1));
    const toTime = new Date(Date.UTC(year, currentMonth - MONTHS_AGO, 1));
    return { year, currentMonth, fromTime, toTime };
};

const DataLoader = ({
    Reservations,
    VouchersDetails,
    SimpleData,
    Searches,
    Commission,
    Membership,
}) => {
    const dispatch = useDispatch();
    const { id: auxHotelID } = useSelector((state) => state.hotelID);
    const [hotelID, setHotelID] = useState("default");

    const authRoles = useSelector((state) => state.authRoles.edited);
    const authHotels = useSelector((state) => state.authRoles.hotels);

    const dataSimple = useSelector((state) => state.dataSimple);
    const dataBookings = useSelector((state) => state.dataBookings);
    const dataVouchersDetails = useSelector(
        (state) => state.dataVouchersDetails,
    );
    const dataSearches = useSelector((state) => state.dataSearches);
    const dataCommission = useSelector((state) => state.dataCommission);
    const dataMembership = useSelector((state) => state.dataMembership);
    const dataTargets = useSelector((state) => state.dataTargets);
    // const { notifications } = useSelector((state) => state);
    // const { settings } = useSelector((state) => state);

    const auth = useSelector((state) => state.auth);

    const [waitToLoad, setWaitToLoad] = useState(true);

    // If we are showing the grand budapest hotel, it will load Park house
    useEffect(() => {
        if (auxHotelID) {
            // console.log({ auxHotelID });
            if (auxHotelID === "default") setHotelID(DEFAULT_HOTEL);
            else setHotelID(auxHotelID);
        }
    }, [auxHotelID]);

    const firstRange = timesFirstReservations();
    const secondRange = timesSecondReservations();

    /* 1️⃣ First → last 24 months */
    const firstQuery = useGetBookingsQuery(
        {
            hotelID,
            body: {
                from: firstRange.fromTime.toISOString(),
                to: firstRange.toTime.toISOString(),
                dateBy: "ResDate",
            },
        },
        {
            skip:
                !Reservations ||
                hotelID === "default" ||
                (authRoles.length === 0 && authHotels.length === 0),
        },
    );

    /* 2️⃣ Second → historical (old years) */
    const secondQuery = useGetBookingsQuery(
        {
            hotelID,
            body: {
                from: secondRange.fromTime.toISOString(),
                to: secondRange.toTime.toISOString(),
                dateBy: "ResDate",
            },
        },
        {
            /*  After first query           */
            skip:
                firstQuery.isLoading ||
                firstQuery.isUninitialized ||
                !Reservations ||
                hotelID === "default",
        },
    );

    /** Load targets */
    const targetsQuery = useGetTargetsQuery(hotelID, {
        skip:
            !Reservations ||
            hotelID === "default" ||
            (authRoles.length === 0 && authHotels.length === 0),
    });

    useCacheRefresh(firstQuery.refetch, firstQuery.data?.cache_ttl);
    useCacheRefresh(secondQuery.refetch, secondQuery.data?.cache_ttl);

    useEffect(() => {
        if (
            firstQuery.status === "fulfilled" &&
            secondQuery.status === "fulfilled"
        ) {
            // We have both queries data = merge and load full data
            const mergedData = [
                ...secondQuery.data.data,
                ...firstQuery.data.data,
            ];
            const lastResDate = firstQuery.data.last_ResDate;
            dispatch(load_Bookings({ data: mergedData, hotelID, lastResDate }));
        } else if (
            firstQuery.status === "fulfilled" &&
            secondQuery.status !== "fulfilled"
        ) {
            // Hotel changed but only the first query is on cache = partiallyLoad firstQuery data from cache
            const lastResDate = firstQuery.data.last_ResDate;
            dispatch(
                partiallyLoad_Bookings({
                    data: [...firstQuery.data.data],
                    hotelID,
                    lastResDate,
                }),
            );
        } else if (
            firstQuery.status === "pending" &&
            secondQuery.status === "pending"
        ) {
            dispatch(loading_Bookings({ hotelID }));
        }
    }, [firstQuery, secondQuery]);

    // keep modal open until Bookings finishes (loaded | partiallyLoaded)
    useEffect(() => {
        const finished =
            !Reservations ||
            dataBookings.status === "loaded" ||
            dataBookings.status === "partiallyLoaded";

        setWaitToLoad(!finished);
    }, [dataBookings.status]);

    useEffect(() => {
        if (targetsQuery.status === "fulfilled") {
            const response = targetsQuery.data ?? {};

            const rawData = response.data ?? response ?? [];
            const nextData = Array.isArray(rawData) ? rawData : [];

            const rawPeriodRows = response.period ?? [];
            const nextPeriodRows = Array.isArray(rawPeriodRows)
                ? rawPeriodRows
                : [];

            const rawManualTargetsCounts = response.counts ?? [];
            const nextManualTargetsCounts = Array.isArray(
                rawManualTargetsCounts,
            )
                ? rawManualTargetsCounts
                : [];

            const rawPeriodCounts = response.period_counts ?? [];
            const nextPeriodCounts = Array.isArray(rawPeriodCounts)
                ? rawPeriodCounts
                : [];

            const nextTargetsTree =
                response.targets_tree &&
                typeof response.targets_tree === "object"
                    ? response.targets_tree
                    : {};

            dispatch(
                load_Targets({
                    data: nextData,
                    hotelID,
                }),
            );

            dispatch(
                load_ManualTargets({
                    hotelID,
                    filtersKey: null,
                    manualTargets: nextData,
                    periodRows: nextPeriodRows,
                    manualTargetsCounts: nextManualTargetsCounts,
                    periodCounts: nextPeriodCounts,
                    targetsTree: nextTargetsTree,
                }),
            );
        } else if (targetsQuery.status === "pending") {
            dispatch(loading_Targets({ hotelID }));
        } else if (targetsQuery.status === "rejected") {
            dispatch(
                error_Targets({
                    hotelID,
                    error:
                        targetsQuery.error?.data?.message ||
                        targetsQuery.error?.error ||
                        "Could not load targets.",
                }),
            );
        }
    }, [
        targetsQuery.status,
        targetsQuery.data,
        targetsQuery.error,
        hotelID,
        dispatch,
    ]);

    //   __  __                _                   _     _
    //  |  \/  | ___ _ __ ___ | |__   ___ _ __ ___| |__ (_)_ __
    //  | |\/| |/ _ \ '_ ` _ \| '_ \ / _ \ '__/ __| '_ \| | '_ \
    //  | |  | |  __/ | | | | | |_) |  __/ |  \__ \ | | | | |_) |
    //  |_|  |_|\___|_| |_| |_|_.__/ \___|_|  |___/_| |_|_| .__/
    //                                                    |_|
    const [membershipCache, setMembershipCache] = useState({});
    useEffect(() => {
        if (
            ILH_HOTEL_LIST.includes(hotelID) &&
            dataMembership.status === "loaded"
        ) {
            // console.log({ membership_cache: membershipCache });
        }
    }, [dataMembership.status]);

    useEffect(() => {
        if (waitToLoad) return;
        if (
            ILH_HOTEL_LIST.includes(String(hotelID)) &&
            dataMembership.status === "loaded"
        ) {
            // console.log({ case: "loaded", membership_cache: membershipCache });
            return;
        } else if (
            (authRoles.length > 0 || authHotels.length > 0) &&
            ILH_HOTEL_LIST.includes(String(hotelID))
        ) {
            // console.log({ case: "loading" });
            dispatch(loading_Membership(hotelID));

            let endpoints = [];
            let dataToStore = {};
            // TOTAL
            const fetchTotal = async () => {
                try {
                    const response = await Axios.get(
                        `${URLAPI}/membership/total/${92}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${auth.user.jwt}`,
                            },
                        },
                    );
                    setMembershipCache((old) => {
                        return {
                            ...old,
                            total: {
                                cache: response.data.is_cache,
                                time: response.data.time,
                            },
                        };
                    });
                    dataToStore["Total"] = response.data.data;
                } catch (error) {
                    console.error("Error at Membership Totals:", error);
                    throw error;
                }
            };

            // SIGN UPS
            const fetchSignUps = async () => {
                try {
                    const response = await Axios.get(
                        `${URLAPI}/membership/signup/${92}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${auth.user.jwt}`,
                            },
                        },
                    );
                    setMembershipCache((old) => {
                        return {
                            ...old,
                            signUps: {
                                cache: response.data.is_cache,
                                time: response.data.time,
                            },
                        };
                    });
                    dataToStore["Signups"] = response.data.data;
                } catch (error) {
                    console.error("Error at Membership SignUps:", error);
                    throw error;
                }
            };

            let startYear = new Date(dataMembership.addYear, 0, 1);
            let endYear = new Date(dataMembership.addYear + 1, 0, 0);
            // REEPEAT BOOKERS
            const fetchRepeatBookers = async () => {
                try {
                    const response = await Axios.get(
                        `${URLAPI}/membership/repeat_bookers`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${auth.user.jwt}`,
                            },
                            params: {
                                from: startYear,
                                to: endYear,
                            },
                        },
                    );
                    setMembershipCache((old) => {
                        return {
                            ...old,
                            RepeatBookers: {
                                cache: response.data.is_cache,
                                time: response.data.time,
                                args: { from: startYear, to: endYear },
                            },
                        };
                    });
                    dataToStore["RepeatBookers"] = {
                        ...((dataMembership.data ?? {})["RepeatBookers"] ?? {}),
                        ...response.data.data,
                    };
                } catch (error) {
                    console.error("Error at Membership RepeatBookers:", error);
                    throw error;
                }
            };

            const mergeData = (obj1, obj2) => {
                let merged = { ...obj1 };

                for (let key in obj2) {
                    if (obj2.hasOwnProperty(key)) {
                        if (merged.hasOwnProperty(key)) {
                            merged[key] = merged[key].concat(obj2[key]);
                        } else {
                            merged[key] = obj2[key];
                        }
                    }
                }
                return merged;
            };

            // BOOKINGS
            const fetchBookings = async () => {
                try {
                    const response = await Axios.get(
                        `${URLAPI}/membership/bookings/${92}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${auth.user.jwt}`,
                            },
                            params: {
                                from: startYear,
                                to: endYear,
                            },
                        },
                    );
                    setMembershipCache((old) => {
                        return {
                            ...old,
                            bookings: {
                                cache: response.data.is_cache,
                                time: response.data.time,
                                args: { from: startYear, to: endYear },
                            },
                        };
                    });
                    let auxBookings = {
                        ...((dataMembership.data ?? {})["Bookings"] ?? {}),
                    };
                    dataToStore["Bookings"] = mergeData(
                        auxBookings,
                        response.data.data,
                    );
                } catch (error) {
                    console.error("Error at Membership Bookings:", error);
                    throw error;
                }
            };

            // DETAILS
            const fetchDetails = async () => {
                try {
                    const response = await Axios.get(
                        `${URLAPI}/membership/details/${92}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${auth.user.jwt}`,
                            },
                            params: {
                                from: startYear,
                                to: endYear,
                                // useCache: false,
                            },
                        },
                    );
                    setMembershipCache((old) => {
                        return {
                            ...old,
                            details: {
                                cache: response.data.is_cache,
                                time: response.data.time,
                                args: { from: startYear, to: endYear },
                            },
                        };
                    });

                    let auxDetails = {
                        ...((dataMembership.data ?? {})["Details"] ?? {}),
                    };
                    dataToStore["Details"] = mergeData(
                        auxDetails,
                        response.data.data,
                    );
                } catch (error) {
                    console.error("Error at Membership Details:", error);
                    throw error;
                }
            };

            endpoints.push(
                fetchTotal().then(() => {
                    dispatch(
                        partialLoad_Membership({ ...dataToStore }, hotelID),
                    );
                }),
            );

            endpoints.push(
                fetchRepeatBookers().then(() => {
                    dispatch(
                        partialLoad_Membership({ ...dataToStore }, hotelID),
                    );
                }),
            );

            endpoints.push(
                fetchSignUps().then(() => {
                    dispatch(
                        partialLoad_Membership({ ...dataToStore }, hotelID),
                    );
                }),
            );

            endpoints.push(
                fetchBookings().then(() => {
                    dispatch(
                        partialLoad_Membership({ ...dataToStore }, hotelID),
                    );
                }),
            );

            endpoints.push(
                fetchDetails().then(() => {
                    dispatch(
                        partialLoad_Membership({ ...dataToStore }, hotelID),
                    );
                }),
            );

            Promise.all(endpoints)
                .then(() => {
                    dispatch(load_Membership(dataToStore, hotelID));
                    // console.log("Finished", dataToStore);
                })
                .catch((error_) => {
                    dispatch(error_Membership(error_, dataToStore));
                    // console.log("Finished with error", error_, dataToStore);
                });
        } else {
            // console.log({
            //     case: "not load",
            //     authRoles,
            //     authHotels,
            //     ILH_HOTEL_LIST,
            //     hotelID,
            // });
        }
    }, [
        hotelID,
        dataMembership.reload,
        dataMembership.addYear,
        waitToLoad,
        authHotels,
    ]);

    //   ____  _                 _
    //  / ___|(_)_ __ ___  _ __ | | ___
    //  \___ \| | '_ ` _ \| '_ \| |/ _ \
    //   ___) | | | | | | | |_) | |  __/
    //  |____/|_|_| |_| |_| .__/|_|\___|
    //                    |_|
    useEffect(() => {
        if (waitToLoad) return;
        if (
            (authRoles.length === 0 && authHotels.length === 0) ||
            !SimpleData ||
            hotelID === "default" ||
            (hotelID === dataSimple.hotelID && dataSimple.status === "loaded")
        ) {
            return;
        }

        const shouldLoad = (endpoint) =>
            // If it is an array, loads only the endpoints from that Array
            // If it is a bool, loads all
            (Array.isArray(SimpleData) && SimpleData.includes(endpoint)) ||
            (!Array.isArray(SimpleData) && SimpleData);

        let dataToStore = { ...dataSimple.data };

        dispatch(loading_Simple(hotelID));

        let endpoints = [];

        //  ___            _
        // / __| ___ _____(_)___ _ _  ___
        // \__ \/ -_|_-<_-< / _ \ ' \(_-<
        // |___/\___/__/__/_\___/_||_/__/
        const fetchSessions2 = async () => {
            try {
                const response = await Axios({
                    method: "get",
                    url: `${URLAPI}/sessions2/${hotelID}`,
                    params: {
                        from: secondRange.fromTime.toISOString(),
                        to: firstRange.toTime.toISOString(),
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.user.jwt}`,
                    },
                });

                dataToStore["Sessions2"] = response.data.data;
            } catch (error) {
                console.error("Error at Sessions2:", error);
                throw error;
            }
        };

        //   ___         _ _         _
        //  |_ _|_ _  __| (_)__ __ _| |_ ___ _ _ ___
        //   | || ' \/ _` | / _/ _` |  _/ _ \ '_(_-<
        //  |___|_||_\__,_|_\__\__,_|\__\___/_| /__/
        const fetchIndicators = async () => {
            try {
                const response = await Axios.get(
                    `${URLAPI}/indicators/${hotelID}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${auth.user.jwt}`,
                        },
                    },
                );
                dataToStore["Indicators"] = response.data.data;
            } catch (error) {
                console.error("Error at Indicators:", error);
                throw error;
            }
        };
        //   _           _   ___
        //  | |   ___ __| |_| _ \_____ _____ _ _ _  _ ___
        //  | |__/ _ (_-<  _|   / -_) V / -_) ' \ || / -_)
        //  |____\___/__/\__|_|_\___|\_/\___|_||_\_,_\___|
        const fetchLostRevenueSummary = async () => {
            try {
                const response = await Axios({
                    method: "post",
                    url: `${URLAPI}/lost_revenue/summary/${hotelID}`,
                    data: {},
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.user.jwt}`,
                    },
                });
                dataToStore["LostRevenueSummary"] = response.data.data;
            } catch (error) {
                console.error("Error at LostRevenueSummary:", error);
                throw error;
            }
        };

        //   __  __         _   _    ___
        //  |  \/  |___ _ _| |_| |_ / __|_  _ _ __  _ __  __ _ _ _ _  _
        //  | |\/| / _ \ ' \  _| ' \\__ \ || | '  \| '  \/ _` | '_| || |
        //  |_|  |_\___/_||_\__|_||_|___/\_,_|_|_|_|_|_|_\__,_|_|  \_, |
        //                                                         |__/
        const fetchMonthlySummary = async () => {
            try {
                const response = await Axios({
                    method: "get",
                    url: `${URLAPI}/month_summary/${hotelID}`,
                    params: {
                        from: `${new Date().getUTCFullYear()}-01-01`,
                        to: `${new Date().getUTCFullYear() + 2}-01-01`,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.user.jwt}`,
                    },
                });
                dataToStore["MonthSummary"] = response.data.data;
            } catch (error) {
                console.error("Error at MonthSummary:", error);
                throw error;
            }
        };

        //   ____       _
        //  |  _ \ __ _| |_ ___  ___
        //  | |_) / _` | __/ _ \/ __|
        //  |  _ < (_| | ||  __/\__ \
        //  |_| \_\__,_|\__\___||___/
        const fetchRates = async () => {
            try {
                const response = await Axios.get(`${URLAPI}/rates`, {
                    params: {
                        hotel_id: Number(hotelID), // backend expects hotel_id or site_id
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.user.jwt}`,
                    },
                });

                // API shape: { status, count, filters, data: [...] }
                dataToStore["Rates"] = response.data.data;
                // console.log("Rates response", response.data);
            } catch (error) {
                console.error("Error at Rates:", error);
                throw error;
            }
        };

        // ___             _
        // | __|_ _____ _ _| |_ ___
        // | _|\ V / -_) ' \  _(_-<
        // |___|\_/\___|_||_\__/__/

        const fetchEvents = async () => {
            try {
                const bundle = await fetchEventsBundle(
                    SanitizeHotelID(auxHotelID, GBH_ID),
                    {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.user.jwt}`,
                    },
                );
                dataToStore["Events"] = bundle.Events;
            } catch (error) {
                console.error("Error at Events:", error);
                throw error;
            }
        };

        const addEndpoint = (endpointFunc) => {
            endpoints.push(
                endpointFunc().then(() => {
                    dispatch(partialLoad_Simple({ ...dataToStore }, hotelID));
                }),
            );
        };

        if (shouldLoad("Sessions2")) {
            addEndpoint(fetchSessions2);
        }

        if (shouldLoad("Indicators")) {
            addEndpoint(fetchIndicators);
        }

        // if (shouldLoad("LostRevenueSummary")) {
        //     addEndpoint(fetchLostRevenueSummary);
        // }

        if (shouldLoad("MonthSummary")) {
            addEndpoint(fetchMonthlySummary);
        }

        addEndpoint(fetchRates);

        if (shouldLoad("Events")) {
            addEndpoint(fetchEvents);
        }

        Promise.all(endpoints)
            .then(() => {
                dispatch(load_Simple(dataToStore, hotelID));
            })
            .catch((error_) => {
                dispatch(error_Simple(error_, dataToStore));
            });
    }, [hotelID, dataSimple.reload, waitToLoad, authHotels]);

    //  __     __               _                   ____       _        _ _
    //  \ \   / /__  _   _  ___| |__   ___ _ __ ___|  _ \  ___| |_ __ _(_) |___
    //   \ \ / / _ \| | | |/ __| '_ \ / _ \ '__/ __| | | |/ _ \ __/ _` | | / __|
    //    \ V / (_) | |_| | (__| | | |  __/ |  \__ \ |_| |  __/ || (_| | | \__ \
    //     \_/ \___/ \__,_|\___|_| |_|\___|_|  |___/____/ \___|\__\__,_|_|_|___/
    // TODO: review and drop old components
    // useEffect(() => {
    //     if (waitToLoad) return;
    //     if (
    //         (authRoles.length === 0 && authHotels.length === 0) ||
    //         !VouchersDetails ||
    //         hotelID === "default" ||
    //         (hotelID === dataVouchersDetails.hotelID &&
    //             dataVouchersDetails.status === "loaded")
    //     ) {
    //         return;
    //     }

    //     dispatch(loading_VouchersDetails(hotelID));
    //     const year = new Date().getUTCFullYear();
    //     const fromTime = new Date(year - YEARS_BEFORE, 0, 1);
    //     const toTime = new Date(year + 2, 0, 0); // Actual Year + 1

    //     let args = JSON.stringify({
    //         from: fromTime,
    //         to: toTime,
    //     });
    //     let res = {};
    //     Axios({
    //         method: "post",
    //         url: `${URLAPI}/vouchers_details/${hotelID}`,
    //         data: args,
    //         headers: {
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${auth.user.jwt}`,
    //         },
    //     })
    //         .then((response) => {
    //             const {
    //                 data: { data },
    //             } = response;

    //             data.forEach((element) => {
    //                 const { ResDate } = element;
    //                 const year_ = new Date(ResDate).getUTCFullYear();
    //                 const month_ = new Date(ResDate).getUTCMonth();
    //                 if (!res.hasOwnProperty(year_)) res[year_] = {};
    //                 if (!res[year_].hasOwnProperty(months[month_]))
    //                     res[year_][months[month_]] = [];

    //                 res[year_][months[month_]].push(element);
    //             });
    //             return dispatch(load_VouchersDetails(res, hotelID));
    //         })
    //         .catch((error_) => {
    //             dispatch(error_VouchersDetails(error_, res));
    //         });
    // }, [hotelID, dataVouchersDetails.reload, waitToLoad, authHotels]);

    //      _____                          _         _
    //     / ____|                        (_)       (_)
    //    | |     ___  _ __ ___  _ __ ___  _ ___ ___ _  ___  _ __
    //    | |    / _ \| '_ ` _ \| '_ ` _ \| / __/ __| |/ _ \| '_ \
    //    | |___| (_) | | | | | | | | | | | \__ \__ \ | (_) | | | |
    //     \_____\___/|_| |_| |_|_| |_| |_|_|___/___/_|\___/|_| |_|
    const day = new Date().getUTCDate();
    const month = new Date().getUTCMonth();
    const year = new Date().getUTCFullYear();

    const YEARS_TO_LOAD = TOTAL_YEARS_NEEDED;
    const today = new Date();
    const currentYear = today.getUTCFullYear();

    const [getCommissions, lastCommissionResult] = useLazyGetCommissionsQuery();

    useEffect(() => {
        if (!Commission) return;

        // dispatch(setStatusLoading());

        const startYear = currentYear - 2;
        for (let i = 0; i < YEARS_TO_LOAD; i++) {
            const year = startYear + i;
            getCommissions({ year });
        }
    }, [Commission, getCommissions]);

    const refetchCommissions = () => {
        const startYear = currentYear - 2;
        for (let i = 0; i < YEARS_TO_LOAD; i++) {
            getCommissions({ year: startYear + i });
        }
    };
    useCacheRefresh(refetchCommissions, lastCommissionResult.data?.cache_ttl);

    //      _____                     _
    //     / ____|                   | |
    //    | (___   ___  __ _ _ __ ___| |__   ___  ___
    //     \___ \ / _ \/ _` | '__/ __| '_ \ / _ \/ __|
    //     ____) |  __/ (_| | | | (__| | | |  __/\__ \
    //    |_____/ \___|\__,_|_|  \___|_| |_|\___||___/

    const from_cache_searches = new Date(Date.UTC(year - 2, 0, 1));
    const to_cache_searches = new Date(Date.UTC(year, month, 1));
    const from_SearchesDate = new Date(Date.UTC(year, month, 1));
    const to_SearchesDate = new Date(Date.UTC(year, month, day + 1));

    // Searches Recent
    const recentSearchesQuery = useGetSearchesQuery(
        {
            hotelID,
            body: {
                from: from_SearchesDate.toISOString(),
                to: to_SearchesDate.toISOString(),
            },
        },
        {
            skip:
                !Searches ||
                hotelID === "default" ||
                (authRoles.length === 0 && authHotels.length === 0),
        },
    );
    // Searches Old -> Cache
    const oldSearchesQuery = useGetSearchesQuery(
        {
            hotelID,
            body: {
                from: from_cache_searches.toISOString(),
                to: to_cache_searches.toISOString(),
            },
        },
        {
            /*  After first query           */
            skip:
                recentSearchesQuery.isLoading ||
                recentSearchesQuery.isUninitialized ||
                !Searches ||
                hotelID === "default",
        },
    );

    useCacheRefresh(
        recentSearchesQuery.refetch,
        recentSearchesQuery.data?.cache_ttl,
    );
    useCacheRefresh(oldSearchesQuery.refetch, oldSearchesQuery.data?.cache_ttl);

    useEffect(() => {
        if (
            oldSearchesQuery.status === "fulfilled" &&
            recentSearchesQuery.status === "fulfilled"
        ) {
            // We have both queries data = merge and load full data
            const mergedData = [
                ...oldSearchesQuery.data.data,
                ...recentSearchesQuery.data.data,
            ];
            dispatch(load_Searches({ data: mergedData, hotelID }));
        } else if (
            recentSearchesQuery.status === "fulfilled" &&
            oldSearchesQuery.status !== "fulfilled"
        ) {
            // Hotel changed but only the first query is on cache = partiallyLoad firstQuery data from cache
            dispatch(
                partiallyLoad_Searches({
                    data: [...recentSearchesQuery.data.data],
                    hotelID,
                }),
            );
        } else if (
            recentSearchesQuery.status === "pending" &&
            oldSearchesQuery.status === "pending"
        ) {
            dispatch(loading_Searches({ hotelID }));
        }
    }, [oldSearchesQuery, recentSearchesQuery]);

    // keep modal open until Bookings finishes (loaded | partiallyLoaded)
    useEffect(() => {
        const finished =
            !Searches ||
            dataSearches.status === "loaded" ||
            dataSearches.status === "partiallyLoaded";
        // console.log({ dataSearches });

        setWaitToLoad(!finished);
    }, [dataSearches.status]);

    //   ____       _   _   _
    //  / ___|  ___| |_| |_(_)_ __   __ _ ___
    //  \___ \ / _ \ __| __| | '_ \ / _` / __|
    //   ___) |  __/ |_| |_| | | | | (_| \__ \
    //  |____/ \___|\__|\__|_|_| |_|\__, |___/
    //                              |___/
    // TODO: review and drop old components
    // useEffect(() => {
    //     if (waitToLoad) return;
    //     if (
    //         (authRoles.length === 0 && authHotels.length === 0) ||
    //         auth.loading !== false
    //     ) {
    //         return;
    //     }
    //     dispatch(load_Settings(auth.user.user_id));
    // }, [auth, settings.reload, waitToLoad]);

    //  _                    _ _
    // | |    ___   __ _  __| (_)_ __   __ _
    // | |   / _ \ / _` |/ _` | | '_ \ / _` |
    // | |__| (_) | (_| | (_| | | | | | (_| |
    // |_____\___/ \__,_|\__,_|_|_| |_|\__, |
    //                                 |___/

    const DataToLoad = {
        ...(Reservations && { dataBookings: dataBookings }),
        ...(SimpleData && { dataSimple: dataSimple }),
        ...(VouchersDetails && { dataVouchersDetails: dataVouchersDetails }),
        ...(Searches && { dataSearches: dataSearches }),
        ...(Commission && { dataCommission: dataCommission }),
        ...(Membership && { dataMembership: dataMembership }),
    };

    const isDataLoading = () => {
        let dataLoading = Object.values(DataToLoad).every(
            (dataType) => dataType.status !== "loaded",
        );

        let partiallyReservations = Reservations
            ? dataBookings.status === "partiallyLoaded"
            : false;
        let partiallySearches = Searches
            ? dataSearches.status === "partiallyLoaded"
            : false;

        return partiallyReservations || partiallySearches ? false : dataLoading;
    };

    const [openLoadingMessage, setOpenLoadingMessage] = useState(true);
    useEffect(() => {
        if (isDataLoading()) {
            setOpenLoadingMessage(true);
        } else {
            setOpenLoadingMessage(false);
        }
    }, [
        dataBookings.status,
        dataCommission.status,
        dataSimple.status,
        dataVouchersDetails.status,
        dataSearches.status,
        hotelID,
    ]);

    return (
        <>
            <Modal
                open={openLoadingMessage}
                onClose={(event, reason) => {
                    if (
                        reason !== "backdropClick" &&
                        reason !== "escapeKeyDown"
                    ) {
                        setOpenLoadingMessage(false);
                    }
                }}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box component={Paper} sx={{ p: 5 }}>
                    <Stack direction={"column"} spacing={3}>
                        <Stack
                            direction={"row"}
                            spacing={1}
                            sx={{
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography variant="h5">Data loading</Typography>
                            <CircularProgress />
                        </Stack>

                        <Stack
                            direction={"row"}
                            spacing={1}
                            sx={{ justifyContent: "center" }}
                        >
                            {BUBBLES_DATA()
                                .filter(({ k }) => DataToLoad.hasOwnProperty(k))
                                .map(({ k, t, reload }) => {
                                    return (
                                        <LoadingBubble
                                            key={k}
                                            dataKey={k}
                                            title={t}
                                            reload={reload}
                                        />
                                    );
                                })}
                        </Stack>
                        <Stack direction="row" spacing={1}>
                            <Button
                                startIcon={<Icons.Refresh />}
                                variant="outlined"
                                onClick={() => window.location.reload()}
                            >
                                Refresh page
                            </Button>
                            <Button
                                startIcon={<Icons.LogOut />}
                                variant="outlined"
                                onClick={() => {
                                    localStorage.clear();
                                    window.location.reload(false);
                                }}
                            >
                                Log out
                            </Button>
                        </Stack>
                        <CheckShow rolesThatCanSee={ARO_ALL}>
                            <HotelSelector />
                        </CheckShow>
                    </Stack>
                </Box>
            </Modal>
        </>
    );
};

export default DataLoader;
